module.exports = "<!-- nav bar-->\n<ld-nav></ld-nav>\n\n<!-- content -->\n<div class=\"site-content\">\n  <ld-messages></ld-messages>\n  <router-outlet></router-outlet>\n</div>\n\n<!-- footer -->\n<div class=\"footer ui center aligned grid\">\n  <div class=\"sixteen wide column\">\n    Lonard.org • Made with <strong class=\"large red text\">♡</strong> by <a href=\"https://lonestone.consulting\">Lone Stone Studio</a>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/components/layout/layout.component.html
// module id = 1015
// module chunks = 0